<template>
  <router-link
    class="c-orange d-flex align-items-center shadow border-radius bg-white p-1 no-text-decoration col-md-12 col-lg-6 col-xl-6 mt-2"
    :to="{ name: routeName }"
  >
    <div class="d-flex w-100 col-12 align-items-center">
      <i :class="` ${icon} menu-icon d-flex fs-18 mr-2`"></i>
      <span class="c-black fs-15">
        {{ text }}
      </span>
    </div>
  </router-link>
</template>

<script>
export default {
  props: {
    routeName: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>
.border-radius {
  border-radius: 8px;
}

.no-text-decoration:hover {
  color: var(--orange-primary);
  text-decoration: none;
}
</style>
